import { useLang } from 'hooks/lang';

import { Column, Row } from 'components/Blocks';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';
import { CircleDollarIcon, PencilIcon, UserSpeakIcon, UserSquareIcon } from 'components/Icons';
import { SingleProperty } from './SingleProperty';

export function ExtraInformation() {
  const { project } = useProjectProfile();

  const { t } = useLang();

  return (
    <Column gap="6">
      <Row alignItems="stretch">
        <SingleProperty
          label={t('bids-notes')}
          Icon={PencilIcon}
          value={project.observations?.bidsNotes || 'N/A'}
          valueClassName="h-full"
        />

        <SingleProperty
          Icon={UserSquareIcon}
          value={project.observations?.clientNotes || 'N/A'}
          valueClassName="h-full"
          label={t('client-notes')}
        />
      </Row>

      <SingleProperty
        Icon={CircleDollarIcon}
        value={project.observations?.reprice ? project.observations?.repriceDetails : 'N/A'}
        label={t('especial-reprice-condition')}
      />

      <SingleProperty
        Icon={UserSpeakIcon}
        value={project.observations?.recruitment ? project.observations?.recruitmentDetails : 'N/A'}
        label={t('needs-recruitment')}
      />
    </Column>
  );
}
